// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"9627e734","450":"393e31c9"}[chunkId] + ".chunk.js";
};